<template>
  <main id="shuttle-inbound-main">
    <warehouse-list :action-str-mount-chained="actionMountChained" :action-str-select-chained="actionSelectChained" />
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('outbound.shuttleInbound.title') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <search-filter ref="searchFilter" />
        </el-col>
      </el-row>

      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="8" class="default-section-title">
              {{ $t('outbound.shuttleInbound.titleSummary') }}
              <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col>
              <search-summary />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>

<script>
import WarehouseList from '@/components/WarehouseList/WarehouseList';
import { SHUTTLE_INBOUND_SEARCH, SHUTTLE_INBOUND_SET_DEFAULT_FILTERS } from '@/store/actions';
import SearchFilter from './SearchFilter';
import SearchSummary from './SearchSummary';

export default {
  name: 'ShuttleInbound',
  components: {
    SearchFilter,
    SearchSummary,
    WarehouseList,
  },
  computed: {
    actionMountChained() {
      return [SHUTTLE_INBOUND_SET_DEFAULT_FILTERS];
    },
    actionSelectChained() {
      return [SHUTTLE_INBOUND_SEARCH];
    }
  },
  methods: {
    handleRefresh() {
      this.$refs.searchFilter.handleSearch();
    }
  }
};
</script>
